/**
 * Confirms replacing the policy already in the consumer's plan with a newly chosen option. Names both,
 * and when an application was already sent for the current one, says that application stays as it is.
 * Cancelling changes nothing.
 */
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@design-system';
import type { PendingReplacement } from '../hooks/use-select-quote';
import { policyDisplayName } from '../lib/policy-name';

interface ReplaceSelectedPolicyDialogProps {
  replacement: PendingReplacement | null;
  newPolicyName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ReplaceSelectedPolicyDialog({
  replacement,
  newPolicyName,
  onConfirm,
  onCancel,
}: ReplaceSelectedPolicyDialogProps) {
  const currentName = replacement ? policyDisplayName(replacement.currentPolicy) : '';

  return (
    <AlertDialog
      open={!!replacement}
      onOpenChange={open => !open && onCancel()}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Replace your selected policy?</AlertDialogTitle>
          <AlertDialogDescription>
            {currentName} will be removed from your plan and {newPolicyName} added.
            {replacement?.currentHasApplication &&
              ` Your application for ${currentName} stays as it is.`}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Keep my current policy</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>Replace it</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
